export default __webpack_public_path__ + "static/media/sportsbra-large-right-toosmall.3a151311.jpg";